import React from "react";
import styles from "./SmallCard.module.css";
import userDataContext from "../../../store/userData-context";
const play = require("../../../images/play-circle.png");

const SmallCard: React.FC<{
  img: string;
  name: string;
  desc: string;
  id: string;
  artist: string;
  mp3: string;
  queue?: {
    img: string;
    name: string;
    desc: string;
    id: string;
    artist: string;
    mp3: string;
  }[];
  shouldNotPlay?: boolean;
}> = (props) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const userDataCtx = React.useContext(userDataContext);
  const { name, img, queue, shouldNotPlay = false } = props;

  function handleMouseLeave() {
    setIsHovered(false);
  }
  function handleMouseEnter() {
    setIsHovered(true);
  }
  function handleClick() {
    if (queue) {
      userDataCtx.setPlaylist(name, queue);
    } else {
      userDataCtx.playSong(props);
      userDataCtx.setPlaylist("", []);
    }
  }
  function handleKeyDown(e: { key: string }) {
    if ((e.key === "Enter" || e.key === "Space") && !shouldNotPlay) {
      handleClick();
    }
  }

  return (
    <article
      data-testid="small-card"
      className={styles["small-card"]}
      role="button"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseEnter}
      onBlur={handleMouseLeave}
      onKeyDown={handleKeyDown}
      onClick={!shouldNotPlay ? handleClick : () => {}}
      tabIndex={0}
      aria-label={`Play the song ${name}`}
    >
      <img className={styles.album} src={img} alt={`${name} Album Cover`} />
      <h3 className={styles.text}>{name}</h3>
      {isHovered && (
        <img
          className={styles.play}
          src={play}
          alt="Play song"
          onClick={!shouldNotPlay ? () => {} : handleClick}
        />
      )}
    </article>
  );
};

export default SmallCard;
